import styled from 'styled-components';

export const EmptySubHeader = styled.h6`
	color: ${(props) => props.theme.v3.colors.dark};
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	padding: 3.5rem;
`;

export const Header = styled.h4`
	color: ${(props) => props.theme.v3.colors.dark};
	text-align: center;
	font-size: 1.5625rem;
	font-style: normal;
	font-weight: 200;
	line-height: 2rem;
`;
